
export const formatearMoneda = (valor, opciones = {}) => {
  const { locale = 'es-CL', currency = 'CLP', decimales = false } = opciones;

  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency,
    minimumFractionDigits: decimales ? 2 : 0,
    maximumFractionDigits: decimales ? 2 : 0,
  }).format(valor);
};

export const quitarFormatoMoneda = (valorFormateado) => {
  if (typeof valorFormateado === 'number') return valorFormateado;
  if (typeof valorFormateado !== 'string') return NaN;

  // Quita todo lo que no sea dígitos o coma o punto
  // Para CLP asumimos que punto es separador de miles y coma decimal
  // Primero removemos puntos (miles), luego cambiamos coma por punto (decimal)
  const limpio = valorFormateado
    .replace(/\$/g, '') // Quita signo $
    .replace(/\./g, '') // Quita puntos miles
    .replace(/,/g, '.')
    .trim();
  const numero = parseFloat(limpio);
  
  return isNaN(numero) ? NaN : numero;
};